// Geometry helpers shared across the hair renderer modules.
//
// Module-level scratch objects assume a single HairRenderer instance per
// page, which matches the app's actual usage (one splat, one renderer).

import * as THREE from 'three';

const _tmpMat4Inv = new THREE.Matrix4();

// L2 distance between two Matrix4s over their 16 elements.
export function matrixDrift(a, b) {
  const ae = a.elements, be = b.elements;
  let s = 0;
  for (let i = 0; i < 16; i++) {
    const d = ae[i] - be[i];
    s += d * d;
  }
  return Math.sqrt(s);
}

export function matricesNearlyEqual(a, b, eps) {
  return matrixDrift(a, b) < eps;
}

// Camera world position transformed into the splat's local (PLY) frame.
/**
 * @param {THREE.Camera}    camera    - the scene camera (its world matrix is read).
 * @param {THREE.Object3D?} splatMesh - the Gaussian-splat mesh whose local frame
 *                                      the camera should be expressed in. Its
 *                                      `.matrix` is treated as local→world
 *                                      (matrixAutoUpdate=false). Pass null to
 *                                      get the camera world position unchanged.
 * @param {THREE.Vector3}   out       - vector written in-place with the result;
 *                                      also returned for chaining.
 * @returns {THREE.Vector3}
 */
export function camPosInSplatLocal(camera, splatMesh, out) {
  camera.getWorldPosition(out);
  if (splatMesh) {
    out.applyMatrix4(_tmpMat4Inv.copy(splatMesh.matrix).invert());
  }
  return out;
}
